import PropTypes from 'prop-types';
import React, {useState} from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import RichAlert from '../../core/feedback/RichAlert';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '../../core/input/Button';
import Dialog from '@material-ui/core/Dialog';
import {Trans, useTranslation} from 'react-i18next';
import {Grid} from '@material-ui/core';
import CountrySelector from '../../core/input/CountrySelector';
import {
	useAffiliateCreateStripeAccountAndGetUrl,
} from '../../../hooks/useAffiliate';

const StripeAccountDialog = ({open, setOpen}) => {
	const {t} = useTranslation();
	const [country, setCountry] = useState(null);
	const [create, creating] = useAffiliateCreateStripeAccountAndGetUrl();

	const handleClose = () => {
		setOpen(false);
	};

	const handleCreate = () => {
		create(country).then(d => {
			if (d && d.url) {
				window.location.href = d.url;
			}
		});
	};

	return (
		<Dialog
			open={open}
			aria-labelledby={t('create_stripe_account_title')}
			aria-describedby={t('create_stripe_account_title')}
		>
			<DialogTitle>
				{t('create_stripe_account_title')}
			</DialogTitle>
			<DialogContent>
				<DialogContentText>
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<RichAlert severity='info'>
								<Trans i18nKey='create_stripe_account_desc'>
									sample<br/>
									<strong>sample</strong>
								</Trans>
							</RichAlert>
						</Grid>
						<Grid item xs={12}>
							<CountrySelector
								value={country}
								setValue={setCountry}
								disabled={creating}
								required
								autoGeoLookup={true}
							/>
						</Grid>
					</Grid>

				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button
					color='default'
					onClick={handleClose}
					disabled={creating}
				>
					{t('close_btn')}
				</Button>
				<Button
					onClick={handleCreate}
					color='primary'
					variant='contained'
					disabled={creating || !country}
					loading={creating}
				>
					{t('create_btn')}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default StripeAccountDialog;

StripeAccountDialog.propTypes = {
	open: PropTypes.bool.isRequired, setOpen: PropTypes.func.isRequired
};
